function toggleAccordion(header) {
    const accordion = header.parentElement;
    const accordionBtn = header;
    const isActive = accordion.classList.contains('active');

    // Close all accordions except the clicked one
    closeAllAccordions(accordion);

    // Toggle a11y attributes
    accordionBtn.setAttribute('aria-expanded', !isActive);

    // Toggle the clicked accordion
    accordion.classList.toggle('active');

    // Toggle arrow icon
    const arrow = header.querySelector('.arrow');
    arrow.classList.toggle('active');
}
  
function closeAllAccordions(currentAccordion) {
    const accordions = document.querySelectorAll('.custom-faq-accordion');
    accordions.forEach(acc => {
        if (acc !== currentAccordion && acc.classList.contains('active')) {
            acc.classList.remove('active');
            
            // Toggle a11y attributes
            const questionBtn = acc.querySelector('.custom-accordion-question');
            if (questionBtn) {
                questionBtn.setAttribute('aria-expanded', 'false');
            }

            // Remove arrow icon
            const arrow = acc.querySelector('.arrow');
            if (arrow) {
                arrow.classList.remove('active');
            }
        }
    });
}
